/* eslint-disable */
import type {
  ProductTimelineResponse,
  AreaListResponse,
} from '../types/productDashboard';

const API_BASE_URL = '/api/proxy/release-assistant-backend/api';

class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public statusText: string
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function fetchApi<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => response.statusText);
    throw new ApiError(
      errorText || `HTTP error! status: ${response.status}`,
      response.status,
      response.statusText
    );
  }

  return response.json();
}

export interface GetProductTimelineParams {
  area?: string; // Comma-separated list of areas
  includeTasks?: boolean;
}

export async function getProductTimeline(
  params: GetProductTimelineParams = {}
): Promise<ProductTimelineResponse> {
  const searchParams = new URLSearchParams();
  
  if (params.area) {
    searchParams.append('area', params.area);
  }
  if (params.includeTasks !== undefined) {
    searchParams.append('include_tasks', params.includeTasks.toString());
  }

  const queryString = searchParams.toString();
  const url = `/product-dashboard/sr-delivery${queryString ? `?${queryString}` : ''}`;
  
  return fetchApi<ProductTimelineResponse>(url);
}

export async function getAreas(): Promise<AreaListResponse> {
  return fetchApi<AreaListResponse>('/product-dashboard/areas');
}
